// src/pages/Reservation.js - VERSION RICH UI cohérente
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import axios from "axios";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=DM+Sans:wght@300;400;500;600&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .resa-page {
    min-height: 100vh;
    background: #f7f4ef;
    font-family: 'DM Sans', sans-serif;
    color: #1a1a1a;
  }

  /* ── NAV ── */
  .resa-nav {
    background: #fff;
    border-bottom: 1px solid #e8e2d9;
    padding: 14px 40px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #aaa;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  }
  .resa-nav a {
    color: #0b1f17;
    text-decoration: none;
    font-weight: 600;
  }
  .resa-nav a:hover { color: #d4a359; }
  .nav-sep { color: #ddd; }

  /* ── HERO ── */
  .resa-hero {
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    padding: 36px 40px;
    position: relative;
    overflow: hidden;
  }
  .resa-hero::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 300px; height: 300px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(212,163,89,0.15) 0%, transparent 70%);
    pointer-events: none;
  }
  .resa-hero-inner {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 24px;
    position: relative;
    z-index: 1;
  }
  .resa-avatar {
    width: 72px; height: 72px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(212,163,89,0.5);
    flex-shrink: 0;
  }
  .resa-avatar-placeholder {
    width: 72px; height: 72px;
    border-radius: 50%;
    background: rgba(255,255,255,0.1);
    border: 3px solid rgba(212,163,89,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .resa-initials {
    font-family: 'Marcellus', serif;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
  }
  .resa-hero-info { flex: 1; }
  .resa-eyebrow {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(255,255,255,0.4);
    margin-bottom: 6px;
  }
  .resa-hero-name {
    font-family: 'Marcellus', serif;
    font-size: clamp(20px, 3vw, 28px);
    font-weight: 700;
    color: #fff;
    margin-bottom: 10px;
    line-height: 1.2;
  }
  .resa-hero-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
  }
  .resa-tag {
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    color: rgba(255,255,255,0.65);
  }
  .resa-tag.gold {
    background: rgba(212,163,89,0.2);
    border-color: rgba(212,163,89,0.4);
    color: #d4a359;
    font-weight: 600;
  }

  /* ── LAYOUT ── */
  .resa-layout {
    max-width: 1000px;
    margin: 0 auto;
    padding: 32px 40px;
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 24px;
    align-items: start;
  }

  /* ── STEP CARD ── */
  .step-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    padding: 28px;
    margin-bottom: 20px;
  }
  .step-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 22px;
  }
  .step-num {
    width: 30px; height: 30px;
    border-radius: 50%;
    background: #0b1f17;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
  }
  .step-title {
    font-family: 'Marcellus', serif;
    font-size: 17px;
    font-weight: 700;
    color: #0b1f17;
  }
  .step-line {
    flex: 1;
    height: 1px;
    background: #f0ebe2;
  }

  /* ── DATE PICKER ── */
  .days-row {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }
  .day-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 10px 4px;
    border-radius: 12px;
    border: 1.5px solid #e0d9ce;
    background: #faf9f7;
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'DM Sans', sans-serif;
  }
  .day-btn:hover:not(:disabled) {
    border-color: #0b1f17;
    background: #f0ebe2;
  }
  .day-btn.selected {
    background: #0b1f17;
    border-color: #0b1f17;
  }
  .day-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  .day-name {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #aaa;
    font-weight: 600;
  }
  .day-btn.selected .day-name { color: rgba(255,255,255,0.6); }
  .day-num {
    font-family: 'Marcellus', serif;
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1;
  }
  .day-btn.selected .day-num { color: #fff; }
  .day-month-label {
    font-size: 10px;
    color: #bbb;
  }
  .day-btn.selected .day-month-label { color: rgba(255,255,255,0.5); }
  .day-dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: #27ae60;
    margin-top: 1px;
  }
  .day-btn.selected .day-dot { background: #d4a359; }

  /* ── TIME SLOTS ── */
  .time-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
  }
  .time-btn {
    padding: 10px 8px;
    border-radius: 10px;
    border: 1.5px solid #e0d9ce;
    background: #faf9f7;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    cursor: pointer;
    transition: all 0.15s;
    text-align: center;
  }
  .time-btn:hover { border-color: #0b1f17; color: #0b1f17; background: #f0ebe2; }
  .time-btn.selected { background: #0b1f17; border-color: #0b1f17; color: #fff; }
  .no-slots {
    text-align: center;
    padding: 32px 20px;
    color: #bbb;
  }
  .no-slots-icon { font-size: 32px; margin-bottom: 10px; opacity: 0.4; }
  .no-slots p { font-size: 14px; }
  .no-slots small { font-size: 12px; margin-top: 4px; display: block; }

  /* ── SIDEBAR ── */
  .resa-sidebar {
    position: sticky;
    top: 60px;
  }
  .summary-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e8e2d9;
    overflow: hidden;
  }
  .summary-header {
    background: linear-gradient(135deg, #0b1f17 0%, #0f3d3d 100%);
    padding: 20px;
  }
  .summary-header-title {
    font-family: 'Marcellus', serif;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 4px;
  }
  .summary-header-sub {
    font-size: 12px;
    color: rgba(255,255,255,0.45);
  }
  .summary-body { padding: 20px; }
  .summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 0;
    border-bottom: 1px solid #f0ebe2;
    gap: 10px;
  }
  .summary-row:last-of-type { border-bottom: none; }
  .summary-label {
    font-size: 12px;
    color: #999;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .summary-val {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    text-align: right;
  }
  .summary-val.empty { color: #ccc; font-weight: 400; font-style: italic; }
  .summary-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0 0;
    margin-top: 4px;
    border-top: 2px solid #f0ebe2;
  }
  .total-label {
    font-size: 14px;
    font-weight: 700;
    color: #0b1f17;
  }
  .total-price {
    font-family: 'Marcellus', serif;
    font-size: 28px;
    font-weight: 700;
    color: #d4a359;
  }
  .total-sub { font-size: 11px; color: #aaa; text-align: right; margin-top: 1px; }

  .btn-confirm {
    display: block;
    width: 100%;
    margin-top: 16px;
    padding: 15px;
    background: #d4a359;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s, transform 0.15s;
    box-shadow: 0 4px 16px rgba(212,163,89,0.3);
  }
  .btn-confirm:hover:not(:disabled) { background: #c49348; transform: translateY(-1px); }
  .btn-confirm:disabled { background: #e0d9ce; color: #aaa; box-shadow: none; cursor: not-allowed; transform: none; }
  .btn-confirm.loading { background: #0b1f17; }

  .confirm-note {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #aaa;
    justify-content: center;
    margin-top: 10px;
  }

  /* ── LOADING / ERROR ── */
  .resa-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    gap: 16px;
    font-family: 'DM Sans', sans-serif;
  }
  .spinner-ring {
    width: 44px; height: 44px;
    border: 3px solid #e0d9ce;
    border-top-color: #0b1f17;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── RESPONSIVE ── */
  @media (max-width: 760px) {
    .resa-hero { padding: 24px 20px; }
    .resa-nav { padding: 12px 20px; }
    .resa-layout {
      grid-template-columns: 1fr;
      padding: 16px;
    }
    .resa-sidebar { position: static; }
    .days-row { grid-template-columns: repeat(7, 1fr); gap: 4px; }
    .day-btn { padding: 8px 2px; }
    .day-num { font-size: 15px; }
  }
`;

const getInitials = (nom = '') => {
  const p = nom.trim().split(' ');
  return p.length >= 2 ? (p[0][0] + p[1][0]).toUpperCase() : nom.slice(0, 2).toUpperCase();
};

const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

export default function Reservation() {
  const [token, setToken] = useState(null);
  const [prof, setProf] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState('');
  const [reserving, setReserving] = useState(false);
  const [backendSlots, setBackendSlots] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [slotsError, setSlotsError] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const profId = new URLSearchParams(location.search).get('prof_id');

  // Auth
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) { navigate('/'); return; }
      setToken(session.access_token);
    });
  }, [navigate]);

  // Chargement prof + dispos
  useEffect(() => {
    if (!token || !profId) return;
    (async () => {
      try {
        const [profRes, availRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/profs`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${process.env.REACT_APP_API_URL}/disponibilites?prof_id=${profId}`, { headers: { Authorization: `Bearer ${token}` } })
        ]);
        const found = profRes.data?.profs?.find(p => p.id === profId);
        if (!found) { setError('Professeur introuvable'); return; }
        setProf(found);
        setAvailableSlots(availRes.data?.disponibilites || []);
      } catch {
        setError('Erreur lors du chargement');
      } finally {
        setLoading(false);
      }
    })();
  }, [token, profId]);

  // Charger les créneaux depuis le backend quand la date change
  useEffect(() => {
    if (!token || !profId || !selectedDate) return;
    // ⚠️ Ne PAS utiliser toISOString() : il convertit en UTC et décale la date d'un
    // jour tôt le matin / tard le soir (ex. 01h à Paris → veille en UTC), ce qui faisait
    // chercher les créneaux du mauvais jour. On construit la date en composants LOCAUX.
    const dateStr = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
    setSlotsLoading(true);
    setSlotsError(false);
    axios.get(`${process.env.REACT_APP_API_URL}/booking/availability/slots/${profId}/${dateStr}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      // On garde l'objet complet : heure prof, heure élève (convertie depuis start_utc), start_utc
      const slotsEnriched = (res.data?.creneaux || []).map(c => {
        const heureProf = c.heure_debut?.slice(0, 5) || '';
        let heureEleve = heureProf;
        if (c.start_utc) {
          try {
            heureEleve = new Date(c.start_utc).toLocaleTimeString([], {
              hour: '2-digit', minute: '2-digit', hour12: false
            });
          } catch {}
        }
        return { heureProf, heureEleve, start_utc: c.start_utc || null };
      });
      setBackendSlots(slotsEnriched);
    }).catch(() => { setBackendSlots([]); setSlotsError(true); })
      .finally(() => setSlotsLoading(false));
  }, [selectedDate, profId, token]);

  // Utilisé UNIQUEMENT pour le petit point indicatif sous chaque jour du sélecteur de semaine
  // (approximation locale, sans conversion TZ — jamais utilisé pour la réservation elle-même).
  const hasAnySlotApprox = (date) => {
    const dayName = JOURS[date.getDay()];
    return availableSlots.some(slot => slot.jour === dayName);
  };
  const hasAnySlot = hasAnySlotApprox;

  // Semaine lundi → dimanche
  const next7Days = (() => {
    const today = new Date();
    const dow = today.getDay();
    const offset = dow === 0 ? -6 : 1 - dow;
    const monday = new Date(today);
    monday.setDate(today.getDate() + offset);
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      return d;
    });
  })();

  const handleReservation = async () => {
    if (!selectedTime) return;
    setReserving(true);
    try {
      const [h, m] = selectedTime.split(':').map(Number);
      const d = new Date(selectedDate);
      d.setHours(h, m, 0, 0);
      const isoDate = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;

      await axios.post(`${process.env.REACT_APP_API_URL}/booking/reservations`, {
        prof_id: profId,
        date: isoDate,
        heure_debut: selectedTime,
        duree_minutes: 30,
        message_eleve: "Réservation depuis l'interface web",
        // Fuseau du navigateur de l'élève : stocké pour afficher la bonne heure
        // (heure locale de l'élève) dans les emails de confirmation/rappel.
        timezone_eleve: (Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Paris')
      }, { headers: { Authorization: `Bearer ${token}` } });

      navigate('/dashboard');
    } catch (err) {
      alert(`❌ ${err?.response?.data?.error || 'Erreur lors de la réservation'}`);
    } finally {
      setReserving(false);
    }
  };

  // États
  if (!profId) return (
    <div className="resa-page">
      <style>{styles}</style>
      <div className="resa-center">
        <div style={{ fontSize: 40 }}>⚠️</div>
        <p style={{ color: '#666' }}>Aucun professeur sélectionné.</p>
        <Link to="/professeurs" style={{ color: '#0b1f17', fontWeight: 600 }}>← Choisir un professeur</Link>
      </div>
    </div>
  );

  if (loading || !token) return (
    <div className="resa-page">
      <style>{styles}</style>
      <div className="resa-center">
        <div className="spinner-ring" />
        <span style={{ color: '#999', fontSize: 14 }}>Chargement…</span>
      </div>
    </div>
  );

  if (error || !prof) return (
    <div className="resa-page">
      <style>{styles}</style>
      <div className="resa-center">
        <div style={{ fontSize: 40 }}>❌</div>
        <p style={{ color: '#666' }}>{error || 'Professeur non trouvé'}</p>
        <Link to="/professeurs" style={{ color: '#0b1f17', fontWeight: 600 }}>← Retour aux professeurs</Link>
      </div>
    </div>
  );

  const nom = prof.prenom ? `${prof.prenom} ${prof.nom}` : prof.nom;
  // Toujours issus de backendSlots (convertis via start_utc) pour la date sélectionnée —
  // plus jamais de fallback non-converti qui affichait l'heure brute du prof à l'élève.
  const timeSlots = backendSlots;

  return (
    <div className="resa-page">
      <style>{styles}</style>

      {/* NAV */}
      <div className="resa-nav">
        <Link to="/professeurs">Professeurs</Link>
        <span className="nav-sep">›</span>
        <Link to={`/professeur/${prof.id}`}>{nom}</Link>
        <span className="nav-sep">›</span>
        <span>Réservation</span>
      </div>

      {/* HERO */}
      <div className="resa-hero">
        <div className="resa-hero-inner">
          {prof.photo_url ? (
            <img className="resa-avatar" src={prof.photo_url} alt={nom} />
          ) : (
            <div className="resa-avatar-placeholder">
              <span className="resa-initials">{getInitials(prof.nom)}</span>
            </div>
          )}
          <div className="resa-hero-info">
            <div className="resa-eyebrow">Réservation de cours</div>
            <div className="resa-hero-name">Cours avec {nom}</div>
            <div className="resa-hero-tags">
              {(prof.specialites || []).slice(0, 3).map((s, i) => (
                <span key={i} className="resa-tag">{s}</span>
              ))}
              {prof.prix_30min && (
                <span className="resa-tag gold">💶 {prof.prix_30min}€ / 30 min</span>
              )}
              {prof.prix_60min && (
                <span className="resa-tag" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  {prof.prix_60min}€ / 60 min
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* LAYOUT */}
      <div className="resa-layout">

        {/* GAUCHE */}
        <div>
          {/* Étape 1 — Date */}
          <div className="step-card">
            <div className="step-header">
              <div className="step-num">1</div>
              <div className="step-title">Choisir une date</div>
              <div className="step-line" />
            </div>
            <div className="days-row">
              {next7Days.map((date, i) => {
                const isPast = date < new Date().setHours(0,0,0,0);
                const isSelected = selectedDate.toDateString() === date.toDateString();
                const hasSlots = !isPast && hasAnySlot(date);
                return (
                  <button
                    key={i}
                    className={`day-btn ${isSelected ? 'selected' : ''}`}
                    disabled={isPast}
                    onClick={() => { setSelectedDate(date); setSelectedTime(''); }}
                  >
                    <span className="day-name">
                      {date.toLocaleDateString('fr-FR', { weekday: 'short' })}
                    </span>
                    <span className="day-num">{date.getDate()}</span>
                    <span className="day-month-label">
                      {date.toLocaleDateString('fr-FR', { month: 'short' })}
                    </span>
                    {hasSlots && <span className="day-dot" />}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Étape 2 — Créneau */}
          <div className="step-card">
            <div className="step-header">
              <div className="step-num">2</div>
              <div className="step-title">Choisir un créneau</div>
              <div className="step-line" />
              <span style={{ fontSize: 12, color: '#bbb', whiteSpace: 'nowrap' }}>
                {selectedDate.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
              </span>
            </div>
            {slotsLoading ? (
              <div className="no-slots">
                <p>Chargement des créneaux…</p>
              </div>
            ) : slotsError ? (
              <div className="no-slots">
                <div className="no-slots-icon">⚠️</div>
                <p>Impossible de charger les créneaux</p>
                <small>Réessayez ou changez de date</small>
              </div>
            ) : timeSlots.length === 0 ? (
              <div className="no-slots">
                <div className="no-slots-icon">😔</div>
                <p>Aucun créneau disponible ce jour</p>
                <small>Essayez une autre date</small>
              </div>
            ) : (
              <div className="time-grid">
                {timeSlots.map(slot => (
                  <button
                    key={slot.heureProf}
                    className={`time-btn ${selectedTime === slot.heureProf ? 'selected' : ''}`}
                    onClick={() => setSelectedTime(slot.heureProf)}
                    title={slot.heureProf !== slot.heureEleve ? `Heure du professeur : ${slot.heureProf}` : undefined}
                  >
                    {slot.heureEleve}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* SIDEBAR */}
        <div className="resa-sidebar">
          <div className="summary-card">
            <div className="summary-header">
              <div className="summary-header-title">📋 Résumé</div>
              <div className="summary-header-sub">Votre réservation</div>
            </div>
            <div className="summary-body">
              <div className="summary-row">
                <span className="summary-label">👨‍🏫 Professeur</span>
                <span className="summary-val">{nom}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">📅 Date</span>
                <span className={`summary-val ${!selectedDate ? 'empty' : ''}`}>
                  {selectedDate
                    ? selectedDate.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })
                    : 'Non choisie'}
                </span>
              </div>
              <div className="summary-row">
                <span className="summary-label">🕒 Heure</span>
                <span className={`summary-val ${!selectedTime ? 'empty' : ''}`}>
                  {selectedTime
                    ? (timeSlots.find(s => s.heureProf === selectedTime)?.heureEleve || selectedTime)
                    : 'Non choisi'}
                </span>
              </div>
              <div className="summary-row">
                <span className="summary-label">⏱ Durée</span>
                <span className="summary-val">30 minutes</span>
              </div>

              {prof.prix_30min && (
                <div className="summary-total">
                  <div>
                    <div className="total-label">Total</div>
                    <div className="total-sub">1 crédit utilisé</div>
                  </div>
                  <div>
                    <div className="total-price">{prof.prix_30min}€</div>
                  </div>
                </div>
              )}

              <button
                className={`btn-confirm ${reserving ? 'loading' : ''}`}
                disabled={!selectedTime || reserving}
                onClick={handleReservation}
              >
                {reserving ? '⏳ Envoi en cours…' : '✅ Confirmer la réservation'}
              </button>
              <div className="confirm-note">
                🔒 Le prof confirmera votre demande
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
